<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card>
      <v-card-title> Change payment terms </v-card-title>
      <v-card-text>
        <VButtons :items="items" @onPress="onPress" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BackButton from "../../../../common/BackButton.vue";
import VButtons from "../../../../common/VButtons.vue";
export default {
  data() {
    return {
      items: [
        {
          title: "Change Downpayment Terms",
          route: "change-downpayment-terms",
        },
        {
          title: "Change due date",
          route: "change-due-date",
        },
        {
          title: "Re-structure my account",
          route: "re-structure",
        },
        {
          title: "Change Registration Fee terms",
          route: "change-registration",
        },
        {
          title: "Change Move-in Fee terms",
          route: "change-downpayment-terms",
        },
      ],
    };
  },
  components: { VButtons, BackButton },
  methods: {
    back(e) {
      this.$router.push({ name: e });
    },
  },
};
</script>
